import { CrossFrameUtils } from '@amzn/jwo-store-management-platform-components'
import _ from 'lodash'

/**
 * Nothing to do here, but function is required by IhmSXClient
 */
function registerScanner (window: any) {
    console.info('ATBase: Registering scanner handler')
}

/**
 * Called when a barcode is scanned. Possible methods include:
 *   - OnBarcode
 *   - OnSwipe
 *   - OnInput
 *   - OnBridge
 * TC70s should only ever receive OnBarcode
 */
function handleScan (method, param) {
    console.info('ATBase: sxOnNativeMethod called')
    switch (method) {
    case 'OnBarcode':
        handleOnBarcode(param)
        break
    default:
        console.warn('Method not handled by sxOnNativeMethod: ' + method)
    }
}

function handleOnBarcode (param) {
    console.info('ATBase: Handling scanned barcode with params: ', param)
    if (param && typeof param.barcode === 'string' && param.barcode.length > 0) {
        if (typeof param.base64EncodedBarcode === 'string' && param.base64EncodedBarcode.length > 0) {
            sendBarcodeToTool({
                barcode: param.barcode,
                base64EncodedBarcode: param.base64EncodedBarcode,
            })
        } else {
            sendBarcodeToTool({
                barcode: param.barcode,
            })
        }
        return
    }
    const params = JSON.parse(param)
    if (_.has(params, 'Barcode') && _.has(params, 'base64EncodedBarcode')) {
        sendBarcodeToTool({
            barcode: params.Barcode,
            base64EncodedBarcode: params.base64EncodedBarcode,
        })
    } else if (_.has(params, 'Barcode') && !_.has(params, 'base64EncodedBarcode')) {
        console.info('ATBase: SXClient OnBarcode missing base64EncodedBarcode property')
        sendBarcodeToTool({
            barcode: params.Barcode,
        })
    } else {
        console.error('ATBase: SXClient OnBarcode missing Barcode property')
        return
    }
}

function sendBarcodeToTool (barcode) {
    console.info('ATBase: Broadcasting barcode scanned event.')
    // TODO: Need to send the msg to both tool iframe.
    const seawardIframe: any = document.getElementsByClassName('seaward-iframe-container')

    if (!seawardIframe) {
        return
    }

    CrossFrameUtils.sendMessageToOtherFrame({
        frame: seawardIframe.contentWindow,
        message: {
            method: 'atbBroadcastBarcode',
            data: barcode,
        },
    })
}

// If the new style listener is present, register to callback.
(window as any).atHandleOnBarCode = handleOnBarcode

if ((window as any).scannerListener) {
    console.info('ATBase: scannerListener found');
    (window as any).scannerListener.addEventListener('onscan', handleOnBarcode, false)
}

// TODO Only attach methods if isWindows (update: isAndroid, rather.)
(window as any).sxOnInit = registerScanner;
(window as any).sxOnNativeMethod = handleScan
